export default "__VITE_ASSET__BRWxlEbR__"